import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ComponentFactoryResolver, ComponentRef, OnInit, ViewChild, ViewContainerRef, WritableSignal, computed, model, signal } from '@angular/core';
import { UuidService } from 'src/app/utility/uuid.service';
import { TripActualHistoryReportComponent } from '../trip-actual-history-report/trip-actual-history-report.component';
import { CardModule } from 'primeng/card';
import { IconService } from 'src/app/ui/icon.service';
import { UiModule } from 'src/app/ui/ui.module';
import { NgClass } from '@angular/common';


interface ReportInstance {
  id: string
}

interface DashboardComponent {
  // Interface to ensure added components have a title (or other common property)
  title: string;
}



@Component({
    selector: 'app-trip-actual-history-report-container',
    imports: [CardModule, UiModule, NgClass],
    templateUrl: './trip-actual-history-report-container.component.html',
    styleUrl: './trip-actual-history-report-container.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})



export class TripActualHistoryReportContainerComponent implements OnInit, AfterViewInit {


 

  layoutOptions = [1,2,3]

  cols: number = 1; 
  @ViewChild('componentHost', { read: ViewContainerRef }) componentHost!: ViewContainerRef;
  componentRefs: ComponentRef<TripActualHistoryReportComponent>[] = []; // Store component references

  constructor(
     public icons: IconService,
     private chRef: ChangeDetectorRef
    ) {}


  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {
    this.addComponent()
  }

  setLayout(cols: number) {
    this.cols = cols;
  }

  addComponent() {
   

    
    const componentRef = this.componentHost.createComponent(TripActualHistoryReportComponent);
    this.componentRefs.push(componentRef); // Add the component ref to the array
    this.chRef.detectChanges()
    // You can access and manipulate the created component instance:
    // const instance = componentRef.instance;
    // instance.someProperty = 'someValue';
  }
}

